import React from 'react'
import { useTheme, css } from '@emotion/react'
import clsx from 'clsx'

function Divider({
    orientation = 'horizental',
    tight,
    width = '100%',
    className,
    withGradient,
    depth = '1px',
    spacer = 'md',
    color,
    style
}) {
    const theme = useTheme()

    const gradientStyle = css`
        border: none;
        background: linear-gradient(
            45deg,
            ${theme.colors.violet} 0%,
            ${theme.colors.primary} 50%,
            ${theme.colors.aquamarine} 100%
        );
        background-repeat: no-repeat;
    `

    function paddingSwitch(space) {
        const spacing = theme.spacing
        switch (space) {
            case 'none':
                return 0
            case 'xs':
                return spacing.one
            case 'sm':
                return spacing.two
            case 'md':
                return spacing.four
            case 'lg':
                return spacing.six
            case 'xl':
                return spacing.eight
            case 'xxl':
                return spacing.ten
            default:
                return spacing.six
        }
    }

    return (
        <>
            {orientation === 'horizental' && (
                <hr
                    className={clsx(className)}
                    css={css`
                        ${!tight &&
                        `margin-top: ${paddingSwitch(spacer)};
                            margin-bottom: ${paddingSwitch(spacer)};`}
                        ${color && `border-color: ${theme.colors[color]}`};
                        display: block;
                        ${withGradient && gradientStyle};
                        height: ${depth};
                        width: ${width};
                        ${style};
                    `}
                />
            )}
        </>
    )
}

export default Divider
